import React from "react";
import { Controller } from "react-hook-form";
import { FieldProp } from "../model/FieldProp";
import { DropdownBooleanModel } from "../../../businessFoundation/Primitives/DropdownBooleanManage/DropdownBooleanModel";
import { ExposedDropdownMenu } from "@episerver/ui-framework";

const DropdownBooleanField: React.FC<FieldProp<any>> = (props) => {
    const { index, property, control, setValue } = props;
    const validationData = property.validationData as DropdownBooleanModel;

    return (
        <Controller
            name={`extendedProperties[${index}].value`}
            control={control}
            render={({ field: { value } }) => (
                <ExposedDropdownMenu
                    label={property.friendlyName}
                    options={[
                        { label: validationData.trueText, value: "true" },
                        { label: validationData.falseText, value: "false" },
                    ]}
                    value={value?.toString() ?? ""}
                    onValueChange={(val: string) => {
                        setValue(`extendedProperties[${index}].value`, val);
                    }}
                />
            )}
        />
    );
};

export default DropdownBooleanField;
